/**
 * @generated SignedSource<<b6f4152ddad1795384eadaf9dfa49ae8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TaskSentiment = "NEGATIVE" | "NEUTRAL" | "POSITIVE";
import { FragmentRefs } from "relay-runtime";
export type TeamScheduleAdminItemComponent_routine$data = {
  readonly activeVersion: {
    readonly tasks: ReadonlyArray<{
      readonly __typename: string;
      readonly id: string;
      readonly sentiments?: ReadonlyArray<TaskSentiment>;
      readonly title: string;
    }>;
  };
  readonly assignedRoles: ReadonlyArray<{
    readonly role: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"ListItemRoles_roles">;
    };
  }>;
  readonly id: string;
  readonly isOrg: boolean;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleRoutineListItemContent_Routine">;
  readonly " $fragmentType": "TeamScheduleAdminItemComponent_routine";
};
export type TeamScheduleAdminItemComponent_routine$key = {
  readonly " $data"?: TeamScheduleAdminItemComponent_routine$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleAdminItemComponent_routine">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamScheduleAdminItemComponent_routine",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOrg",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RoutineVersion",
      "kind": "LinkedField",
      "name": "activeVersion",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "tasks",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "sentiments",
                  "storageKey": null
                }
              ],
              "type": "TaskCheck",
              "abstractKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AssignedRole",
      "kind": "LinkedField",
      "name": "assignedRoles",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EmployeeRole",
          "kind": "LinkedField",
          "name": "role",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ListItemRoles_roles"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamScheduleRoutineListItemContent_Routine"
    }
  ],
  "type": "Routine",
  "abstractKey": null
};
})();

(node as any).hash = "284ba0927a8ec2db4b43fd59fc8837c0";

export default node;
